import React, { useContext } from 'react';
import {
  PlayContext,
  PlayObjectProperty,
} from '@bbkAdminComponents/play/play-context';
import { SingleOffer } from '@bbkAdminComponents/play/offer-components/single-offer';
import { ABTestOffer } from '@bbkAdminComponents/play/offer-components/test-offer';
import { SubAudOffer } from '@bbkAdminComponents/play/offer-components/sub-aud-offer';

export enum OfferNodeType {
  OFFER = 'offer',
  TEST = 'test',
  SUB_AUDI_SPLIT = 'sub_aud_split',
}

export const PlayOfferNodeSelect = () => {
  const { getPlayObjectProperty } = useContext(PlayContext);
  const offerNodeType = getPlayObjectProperty(
    PlayObjectProperty.OFFER_NODE_TYPE
  );

  if (offerNodeType === undefined) return undefined;

  return (
    <div>
      {offerNodeType === OfferNodeType.OFFER && <SingleOffer />}
      {offerNodeType === OfferNodeType.TEST && <ABTestOffer />}
      {offerNodeType === OfferNodeType.SUB_AUDI_SPLIT && <SubAudOffer />}
    </div>
  );
};
